module.exports = __webpack_public_path__ + "img/event_round_duration.71db97dc.svg";